export interface OtherCost {
    id: number | null;
    appraisal_basic_id?: number;
    name: string;
    amount: number;
    is_default: 1 | 0;
}

// to single object maping
export const mapOtherCost = (data: any): OtherCost => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: OtherCost = {
        id: data.id,
        appraisal_basic_id: data.appraisal_basic_id,
        name: data.name,
        amount: data.amount,
        is_default: data.is_default,
    }
    return res;
}

// maping list objects
export const mapOtherCosts = (data: any[]): OtherCost[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapOtherCost);
}